import React, { Suspense } from 'react';
import { AudioConfig } from '../types';

// Lazy load the audio player for performance
const LazyAbielAudioPlayer = React.lazy(() =>
  import('@/components/audio/AbielAudioPlayer').then(module => ({
    default: module.AbielAudioPlayer
  }))
);

interface StandardDialogAudioPlayerProps extends AudioConfig {
  // Additional props can be added here
}

const StandardDialogAudioPlayer: React.FC<StandardDialogAudioPlayerProps> = ({
  enabled = true,
  prayer,
  variant = 'golden',
  collapsible = true,
  autoPlayWelcome = true,
  onExpansionChange
}) => {
  if (!enabled || !prayer) return null;

  // Map variant to valid AbielAudioPlayer variant - fix the invalid "header" variant
  const audioPlayerVariant = variant === 'standard' ? 'default' : 'golden';

  return (
    <div className="mx-4 relative">
      <Suspense fallback={
        <div className="h-16 bg-gradient-to-r from-gold/10 to-amber-600/10 rounded-lg animate-pulse" />
      }>
        <LazyAbielAudioPlayer
          prayer={prayer}
          variant={audioPlayerVariant}
          collapsible={collapsible}
          autoPlayWelcome={autoPlayWelcome}
          onExpansionChange={onExpansionChange}
          positioning="relative"
        />
      </Suspense>
    </div>
  );
};

export default StandardDialogAudioPlayer;
export { StandardDialogAudioPlayer };
